import React from 'react';
import moment from 'moment';
import { Tag, Tooltip } from 'antd';
import { MoreMenu, MoreTags } from 'datastake-daf/dist/components';

export const linkingColumns = (t, module = 'pme') => [];

const ampTagOptions = [
  { label: 'Review', value: 'review' },
  { label: 'Application', value: 'application' },
  { label: 'Assessment', value: 'assessment' },
  { label: 'Pre Assessed', value: 'preAssessed' },
  { label: 'Registered', value: 'registered' },
  { label: 'Declined', value: 'declined' },
];

export const renderAmpTag = ({ status, t }) => {
  let color;

  switch (status?.value) {
    case 'application':
    case 'applied':
      color = 'purple'
      break;
    case 'assessment':
      color = 'blue'
      break;
    case 'declined':
      color = 'red'
      break;
    case 'preAssessed':
    case 'approved':
      color = 'green'
      break;
    case 'registered':
      color = 'orange'
      break;
    case 'review':
      color = 'cyan'
      break;
    default:
  }

  const _label = ampTagOptions.find((o) => o.value === status.value)?.label || status.label;

  return (
    <Tag color={color} style={{ width: 100 }} className="text-center">
      {t(_label)}
    </Tag>
  );
}

export const getStatusObject = (val) => {
  switch (val) {
    case 'approved':
      return { label: 'Approved', value: val };
    case 'declined':
      return { label: 'Declined', value: val };
    case 'review':
      return { label: 'Review', value: val };
    case 'registered':
      return { label: 'Registered', value: val };
    default:
      return { label: val, value: val };
  }
}

export default function getColumns(
  t = s => s,
  module = 'pme',
  filterBy = 'show',
  activeFilters = {},
  push = () => { },
  setEditStatusAmp = () => { },
  user,
  refreshData = () => { },
  setAmpToInvite,
) {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      overview: true,
      ellipsis: true,
      show: true,
      project: true,
      publication: true,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      render: (id, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return id;
      },
      search: true,
      width: 160,
      pubblication: true,
    },
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      defaultSortOrder: activeFilters.sortBy === 'name' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      overview: true,
      show: true,
      project: true,
      publication: true,
      primarySearch: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      show: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
      project: true,
      search: true,
      publication: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'country' ? activeFilters.sortDir : undefined,
      searchType: 'dropdown',
    },
    {
      title: t('Location'),
      dataIndex: 'location',
      key: 'location',
      // sorter: () => 0 + 0,
      // defaultSortOrder: activeFilters.sortBy === 'province' ? activeFilters.sortDir : undefined,
      show: true,
      project: true,
      publication: true,
      search: true,
      render: (location) => {
        return <Tooltip title={location}>{location}</Tooltip>
      },
      ellipsis: true,
    },
    {
      title: t('Product'),
      dataIndex: 'mainMineralProduced',
      key: 'mainMineralProduced',
      // sorter: () => 0 + 0,
      // defaultSortOrder: activeFilters.sortBy === 'province' ? activeFilters.sortDir : undefined,
      show: true,
      project: true,
      publication: true,
      search: true,
      render: (val, all) => {
        if (all.childrens) {
          const v = []

          all.childrens.forEach((ch) => {
            if (ch.mainMineralProduced && !v.includes(ch.mainMineralProduced)) {
              v.push(ch.mainMineralProduced)
            }
          })
          if (!v.length) {
            return '--';
          }
          return <MoreTags values={v.map((m) => ({ value: m, label: m }))} />
        }

        const _val = [val].filter((v) => !!v);

        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        if (!_val.length) {
          return '--';
        }

        return (
          <MoreTags values={_val.map((m) => ({ value: m, label: m }))} />
        )
      },
      ellipsis: true,
    },
    {
      title: t('Sources'),
      dataIndex: 'sources',
      key: 'sources',
      overview: true,
      show: true,
      search: true,
      render: (sources = [], all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        if (all.childrens?.length) {
          return <Tag>{t("Multiple")}</Tag>
        }

        return sources.length ? sources.join(', ') : '--';
      },
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
      overview: true,
      show: true,
      search: true,
      render: (status, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return renderAmpTag({ status, t });
      },
    },
    {
      title: t('Version'),
      dataIndex: 'version',
      key: 'version',
      show: false,
      publication: true,
      ellipsis: true,
    },
    // {
    //   title: t('Sub Category'),
    //   dataIndex: 'subCategory',
    //   key: 'subCategory',
    //   className: 'd-none',
    //   render: (title) => <Tooltip title={title}>{title}</Tooltip>,
    //   ellipsis: true,
    //   show: true,
    //   project: true,
    //   search: true,
    //   publication: true,
    //   searchType: 'dropdown',
    // },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      show: true,
      project: true,
      search: false,
      publication: true,
      ellipsis: true,
      render: (updatedAt, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const date = item.publishedAt || updatedAt;
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: 60,
      show: true,
      project: true,
      publication: false,
      render: (_, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        const analysisView = 'amp';
        const analysisLink = (item.children)
          ? `/app/${module}/analysis/${analysisView}/${item.id}`
          : `/app/${module}/analysis/${analysisView}/${item.id}/${item.authorId}`
        const applicationFormLink = `/app/${module}/view/amp/${item.id}?sourceId=${item.authorId}`;

        let items = [];

        const defaultItems = [
          {
            label: t('Summary'),
            onClick: () => push(analysisLink),
            key: "view",
            disabled: ['application', 'registered'].includes(item?.status?.value),
          },
          {
            label: t('Assessments'),
            onClick: () => { },
            key: "assessments",
            children: [
              {
                label: t('Application Form'),
                onClick: () => push(applicationFormLink),
                key: "edit",
                disabled: ['registered'].includes(item?.status?.value) ||
                  (item?.status?.value === 'assessment' && !item.mineProfileStatus && item.sources.includes('AMP')),
              },
              {
                label: t('Mine Profile'),
                onClick: () => {
                  push(`/app/tif/view/mine-profile/${item.id}?sourceId=${item.authorId}`)
                },
                key: "mineProfile",
                disabled: ['application', 'registered'].includes(item?.status?.value) ||
                  (item?.status?.value === 'assessment' && !item.mineProfileStatus && item.sources.includes('AMP')),
              },
              {
                label: t('Ownership & KYC'),
                onClick: () => {
                  push(`/app/tif/view/ownership-kyc/${item.id}?sourceId=${item.authorId}`)
                },
                key: "ownership&KYC",
                disabled: ['application', 'registered'].includes(item?.status?.value) ||
                  (item?.status?.value === 'assessment' && !item.kycStatus && item.sources.includes('AMP')),
              },
              {
                key: "productionReports",
                onClick: () => {
                  push(`/app/tif/view/production-reports/${item.id}?sourceId=${item.authorId}`)
                },
                label: t('Production & Reports'),
                // disabled: ['application', 'registered'].includes(item?.status?.value),
                disabled: true,
              },
              {
                key: "equipmentsAndInventory",
                onClick: () => {
                  push(`/app/tif/view/equipments-and-inventory/${item.id}?sourceId=${item.authorId}`)
                },
                label: t('Equipments & Inventory'),
                // disabled: ['application', 'registered'].includes(item?.status?.value),
                disabled: true,
              },
              {
                key: "esgAssessment",
                onClick: () => {
                  push(`/app/tif/view/esg-assessment/${item.id}?sourceId=${item.authorId}`)
                },
                label: t('ESG Assessment'),
                // disabled: ['application', 'registered'].includes(item?.status?.value),
                disabled: true,
              },
            ],
            disabled: ['registered'].includes(item?.status?.value) ||
              (item?.status?.value === 'assessment' && !item.mineProfileStatus && item.sources.includes('AMP')),
          },
          {
            label: t('Invite AMP'),
            onClick: () => {
              setAmpToInvite(item);
            },
            key: "invite",
            disabled: item.sources.includes('AMP')
          },
          {
            label: t('Delete'),
            onClick: () => { },
            key: "delete",
            disabled: true,
          },
        ];

        const defaultParentItems = [
          {
            label: t('Summary'),
            onClick: () => push(analysisLink),
            key: "view",
            disabled: ['application'].includes(item?.status?.value),
          },
          {
            label: t('Delete AMP'),
            onClick: () => { },
            key: "delete",
            disabled: true,
          },
        ];

        if (item?.status?.value === 'application') {
          if (item.isChild) {
            items = defaultItems[1].children;
          } else if (item?.childrens?.length) {
            items = defaultParentItems;
          } else {
            items = defaultItems;
          }
        } else if (item?.status?.value === 'declined') {
          items = [
            {
              label: t('View application form'),
              onClick: () => push(`/app/${module}/view/amp/${item.id}`),
              key: "edit",
            },
            {
              label: t('Edit status'),
              onClick: () => setEditStatusAmp(item),
              key: "editStatus",
            },
            {
              label: t('Delete AMP'),
              onClick: () => { },
              disabled: true,
              key: "delete",
            },
          ]
        } else if (item?.childrens?.length) {
          items = defaultParentItems;
        } else if (item?.isChild) {
          items = defaultItems[1].children;
        } else {
          items = defaultItems;
        }

        return <MoreMenu items={items} />;
      }
    }
  ];

  return cols.filter(c => c[filterBy]);
}
